export const column = [
  {
    prop: "path",
    label: "素材",
    width: 300,
  },
  {
    prop: "uuid",
    label: "素材ID",
  },
  {
    prop: "designerName",
    label: "设计",
    // width: 120,
  },
  {
    prop: "tags",
    label: "标签",
  },
  {
    prop: "demanderName",
    label: "后期",
  },
  // {
  //   prop: "creativeSource",
  //   label: "是否原创",
  // },
  {
    prop: "direction",
    label: "素材类别",
    // width: 80,
  },
  {
    prop: "duration",
    label: "时长(s)",
    // width: 80,
  },
  {
    prop: "modifyDate",
    label: "修改时间",
    // width: 160,
  },
  {
    prop: "action",
    label: "操作",
    width: 100,
  },
];
